import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'

import Moment from 'moment'

const Item = props => (
  <tr>
    <td> {(parseInt(props.skip, 0) + props.indexKey + 1)} </td>
    <td>
      <Link to={`/tasklist/${props.row.id}`}>
        {
          props.row.name
          ? <span>{ props.row.name }</span>
          : <span>Content #</span>
        }
      </Link>
    </td>
    <td>
      <span>
        {
          props.row.profile.name
          ? props.row.profile.name
          : 'No Creator Workspace'
        }
      </span>
    </td>
    <td>
      <span>
        {
          props.taskStatusList[props.row.status]
          ? props.taskStatusList[props.row.status]
          : 'No Task Status'
        }
      </span>
    </td>
    <td>
      <span>
        {
          props.row.order.name
          ? props.row.order.name
          : 'No Project Name'
        }
      </span>
    </td>
    <td>
      <span>
        {
          props.row.order.service.name
          ? props.row.order.service.name
          : 'No Project Type'
        }
      </span>
    </td>
    <td>
      {
        props.row.deadline
        ? Moment(`${props.row.deadline}`).format('DD MMMM YYYY')
        : '-'
      }
    </td>
  </tr>
  )


Item.defaultProps = {
  taskStatusList: {},
  skip: 0,
  indexKey: 0,
  row: {
    id: '',
    name: '',
    profile: {
      name: '',
    },
    order: {
      name: '',
      id: '',
      service: {
        name: '',
      },
    },
    deadline: '',
    status: 0,
  },
}

Item.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    profile: PropTypes.shape({
      name: PropTypes.string,
    }),
    order: PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.string,
      service: PropTypes.shape({
        name: PropTypes.string,
      }),
    }),
    deadline: PropTypes.string,
    status: PropTypes.number,
  }),
  taskStatusList: PropTypes.arrayOf(PropTypes.string).isRequired,
  skip: PropTypes.number.isRequired,
  indexKey: PropTypes.number.isRequired,
}

export default Item
